import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import { images } from "../../config/images";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Switch,
  Card,
} from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import "../RawMaterial/RawMaterial.css";
import {
  exportRawMaterialExcel,
  getRawMaterialDetails,
  updateRawMaterialDetails,
} from "./services";
import dayjs from "dayjs";
import COCDatePicker from "../../components/DateTimePicker/DateTimePicker";
import { CardContent } from "@mui/material";
import ExcelIcon from "../../assets/images/excel-icon.svg";
import Button from "../../components/Button/Button";
import { useSelector } from "react-redux";

const RawMaterial = () => {
  const navigate = useNavigate();
  const [debouncedSearchText, setDebouncedSearchText] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedOrderType, setSelectedOrderType] = useState();
  const [getMaterialData, setGetMaterialData] = useState([]);
  const [open, setOpen] = useState(false);
  const [showTime, setShowTime] = useState(false);
  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);
  const [isPopup, setisPopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [selected, setSelected] = React.useState([]);
  const [isExcelDisabled, setIsExcelDisabled] = useState(true);
  const [compounder, setCompounder] = useState("");

  const [editData, setEditData] = useState({
    lotNo: "",
    freshLatexVelocity: "",
    viscosityAfterComp: "",
    mTank: "",
    rpm: "",
    remarks: "",
    id: "",
    batchNo: "",
    foamTest: "",
    specificGravity: "",
    disperson_tank_no: "",
    totalWeight: "",
  });

  const initiallValue = {
    Class: "",
    start_time: "",
    end_time: "",
    compound_name: "",
    batch_number: "",
    lot_no: "",
    recipe_name: "",
    recipe_description: "",
    batch_weight: "",
    operator_name__username: "",
    supervisor_name__username: "",
    qa_supervisor_name__username: "",
    total_batch_weight: "",
  };
  const { userPermission } = useSelector((state) => state.userState);
  const [searchText, setSearchText] = useState(initiallValue);
  const dateFormat = "YYYY-MM-DD";
  const startDateFormat = dayjs(startDateReFormat).format(dateFormat);
  const endDateFormat = dayjs(endDateReFormat).format(dateFormat);

  const DateTimeFormat = (date) => {
    const Date_Time_Format = "YYYY-MM-DD HH:mm:ss";
    // console.log("YYYY-MM-DD hh:mm:ss",dayjs(date).format(Date_Time_Format))
    return dayjs(date).format(Date_Time_Format);
  };
  const handleToastMsg = () => {
    toast.error("You don't have access", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  useEffect(() => {
    if (selectedOrderType !== "all") {
      handleOrderTypeChange();
    } else {
      const params = {
        page: page,
        rowsPerPage: rowsPerPage,
        searchText: searchText,
      };
      // fetchOrderDetailTypeData(params);
    }
  }, [selectedOrderType]);

  const handleOrderTypeChange = async (event) => {
    if (!selectedOrderType) {
      return true;
    }

    const params = {
      order_type: selectedOrderType,
    };
    // try {
    //     const resp = await getOrderbyType(params);
    //     if (resp.status === 200 || resp.status === 201) {
    //         setOrderDetail(resp.data.results);
    //     }
    // } catch (error) {
    //     console.log("handleSubmit", error);
    // }
  };

  const handleExcelClick = async () => {
    setisPopup(false);
    setSuccessPopup(true);
    const params = {
      raw_material_ids: selected,
    };
    if (showTime) {
      const StartDateTime = DateTimeFormat(startDateReFormat);
      const EndDateTime = DateTimeFormat(endDateReFormat);
      params["start_datetime"] = StartDateTime;
      params["end_datetime"] = EndDateTime;
    } else {
      params["start_datetime"] = `${startDateFormat} 00:00:00`;
      params["end_datetime"] = `${endDateFormat} 23:59:59`;
    }
    try {
      const resp = await exportRawMaterialExcel(params);
      setLoading(false);

      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setTimeout(() => {
          setSuccessPopup(false);
        }, 5000);
      } else {
        console.log("Something was wrong, try again");
      }
    } catch (error) {
      // Set loading state to false and log any errors
      setLoading(false);
      toast.error(error.response.data.message);
      console.log("handleSubmit", error);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes

  const handleSearchData = async (e) => {
    // Destructure the name and value of the input field that triggered the change
    const { name, value } = e.target;

    // Update the searchText state object with the new value for the specified input field
    setSearchText({ ...searchText, [name]: value });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleEditClick = (row) => {
    console.log("sdjfkldsjklfsdjkds", row);
    setCompounder(row.compound_name);
    setEditData({
      id: row.id,
      lotNo: row.lot_no,
      freshLatexVelocity: row.fresh_latex_velocity || "",
      viscosityAfterComp: row.viscosity_after_comp || "",
      mTank: row.m_tank || "",
      rpm: row.rpm || "",
      gl02: row.gl02 || "",
      remarks: row.remarks || "",
      batchNo: row.batch_number || "",
      foamTest: row.foam_test || "",
      specificGravity: row.specific_gravity || "",
      disperson_tank_no: row.disperson_tank_no || "",
      totalWeight: row.total_weight || "",
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (field, value) => {
    setEditData({ ...editData, [field]: value });
  };

  const handleUpdate = async () => {
    try {
      const id = editData.id;

      let payload = {};

      if (compounder?.toUpperCase() === "COAGULANT") {
        payload = {
          batch_no: editData.batchNo,
          foam_test: editData.foamTest,
          specific_gravity: editData.specificGravity,
          disperson_tank_no: editData.disperson_tank_no,
          total_weight: editData.totalWeight,
          rpm: editData.rpm,
          remarks: editData.remarks,
        };
      } else {
        payload = {
          lot_no: editData.lotNo,
          fresh_latex_velocity: parseFloat(editData.freshLatexVelocity),
          viscosity_after_comp: parseFloat(editData.viscosityAfterComp),
          m_tank: editData.mTank,
          rpm: editData.rpm,
          gl02: editData.gl02?.toString().includes("KG")
            ? editData.gl02
            : `${editData.gl02} KG`,
          remarks: editData.remarks,
        };
      }

      const response = await updateRawMaterialDetails(id, payload);

      if (response.status === 200 || response.status === 201) {
        toast.success("Raw material details updated successfully!");
        setOpen(false);
        handleGetMaterialData();
      } else {
        throw new Error("Failed to update raw material details");
      }
    } catch (error) {
      console.error("Error updating raw material details:", error);
      toast.error("Failed to update raw material details. Please try again.");
    }
  };

  useEffect(() => {
    if (Object.keys(debouncedSearchText).length > 0) {
      handleGetMaterialData();
    }
  }, [
    page,
    rowsPerPage,
    debouncedSearchText,
    startDateReFormat,
    endDateReFormat,
    showTime,
  ]);

  const handleGetMaterialData = async () => {
    const searchParams = {
      search: debouncedSearchText,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    if (startDateReFormat && endDateReFormat) {
      if (showTime) {
        const StartDateTime = DateTimeFormat(startDateReFormat);
        const EndDateTime = DateTimeFormat(endDateReFormat);
        searchParams["start_datetime"] = StartDateTime;
        searchParams["end_datetime"] = EndDateTime;
      } else {
        searchParams["start_datetime"] = `${startDateFormat} 00:00:00`;
        searchParams["end_datetime"] = `${endDateFormat} 23:59:59`;
      }
    } else {
      searchParams["start_datetime"] = null;
      searchParams["end_datetime"] = null;
    }
    try {
      const resp = await getRawMaterialDetails(searchParams);
      if (resp.status == 200 || resp.status == 201) {
        setGetMaterialData(resp.data.payload);
      }
    } catch (error) {
      setGetMaterialData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setEditData(row);
    setSelected(newSelected);
  };
  useEffect(() => {
    if (startDateReFormat && endDateReFormat) {
      setIsExcelDisabled(false);
    } else {
      setIsExcelDisabled(true);
    }
  }, [startDateReFormat, endDateReFormat]);
  const handleToggleTime = () => {
    setShowTime(!showTime);
  };

  const handleStartDate = (newStartDate) => {
    setStartDateReFormat(newStartDate);
  };

  const handleEndDate = (newEndDate) => {
    if (showTime) {
      setEndDateReFormat(newEndDate);
    } else {
      setEndDateReFormat(dayjs(newEndDate).hour(23).minute(59).second(0));
    }
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  return (
    <>
      <div className="dashboard-wrapper page-wraper">
        <ToastContainer />
        <div className="page-header">
          <Link to="/dashboard" className="page-back-btn">
            <ArrowBackIcon />
            <span>Raw Material</span>
          </Link>

          <div className="d-flex gap-2">
            <FormGroup aria-label="position" row>
              <FormControlLabel
                className="time-picker"
                value="top"
                control={<Switch color="primary" checked={showTime} />}
                label="Test Time"
                labelPlacement="top"
                onChange={handleToggleTime}
              />
            </FormGroup>

            <COCDatePicker
              time={showTime}
              startDateReFormat={startDateReFormat}
              endDateReFormat={endDateReFormat}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              Start_Date_lable={"Test Start Date"}
              end_Date_lable={"Test End Date"}
            />
            {userPermission.find(
              (permission) => permission.module === "Raw Material"
            ).is_editor == true &&
            userPermission.find(
              (permission) => permission.module === "Raw Material"
            ).is_viewer == true ? (
              <button
                className={`page-header-btn ${
                  isExcelDisabled ? "disabled" : ""
                }`}
                disabled={isExcelDisabled}
                onClick={() => setisPopup(true)}
              >
                <img src={ExcelIcon} alt="" />
              </button>
            ) : (
              <button
                className={`page-header-btn ${
                  isExcelDisabled ? "disabled" : ""
                }`}
                disabled={isExcelDisabled}
                onClick={handleToastMsg}
              >
                <img src={ExcelIcon} alt="" />
              </button>
            )}
          </div>
        </div>
        <div className="table-responsive" style={{}}>
          <Table className="productionTable mt-3">
            <TableHead>
              <TableRow>
                <TableCell colSpan={2}>Date</TableCell>
                <TableCell>Start Time</TableCell>
                <TableCell>End Time</TableCell>
                <TableCell>Compound Name</TableCell>
                <TableCell>Batch Number</TableCell>
                <TableCell>Lot No.</TableCell>
                <TableCell>Recipe Name</TableCell>
                <TableCell>Recipe Desc.</TableCell>
                <TableCell>Batch Weight</TableCell>
                <TableCell>Total Weight</TableCell>
                <TableCell>Operator Name</TableCell>
                <TableCell>Supervisor Name</TableCell>
                <TableCell>QA Sup. Name</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Date"
                    name="Date"
                    value={searchText.Date}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Time"
                    name="start_time"
                    value={searchText.start_time}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Time"
                    name="end_time"
                    value={searchText.end_time}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Compound Name"
                    name="compound_name"
                    value={searchText.compound_name}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Batch Number"
                    name="batch_number"
                    value={searchText.batch_number}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Lot No."
                    name="lot_no"
                    value={searchText.lot_no}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Recipe Name"
                    name="recipe_name"
                    value={searchText.recipe_name}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Recipe Desc"
                    name="recipe_description"
                    value={searchText.recipe_description}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Batch Weight"
                    name="batch_weight"
                    value={searchText.batch_weight}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Total Weight"
                    name="total_batch_weight"
                    value={searchText.total_batch_weight}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Operator Name"
                    name="operator_name__username"
                    value={searchText.operator_name__username}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Supervisor Name"
                    name="supervisor_name__username"
                    value={searchText.supervisor_name__username}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="QA Sup Name"
                    name="qa_supervisor_name__username"
                    value={searchText.qa_supervisor_name__username}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Action"
                    name="Action"
                    // value={searchText.Action}
                    // onChange={handleSearchData}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getMaterialData?.results?.map((row) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${row.id}`;
                return (
                  <TableRow
                    role="checkbox"
                    // aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    // selected={isItemSelected}
                  >
                    <TableCell
                      padding="checkbox"
                      style={{ pointerEvents: "all" }}
                    >
                      <Checkbox
                        onClick={(event) => handleClick(event, row.id, row)}
                        color="primary"
                        checked={isItemSelected}
                        // disabled={isCheckboxDisabled(row.batchid)}
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {" "}
                      {dayjs(row.created_at).format("YYYY-MM-DD")}
                    </TableCell>
                    <TableCell>
                      {row.start_time
                        ? dayjs(
                            `${dayjs().format("YYYY-MM-DD")} ${row.start_time}`
                          ).format("HH:mm")
                        : "-"}
                    </TableCell>

                    <TableCell>
                      {row.end_time
                        ? dayjs(
                            `${dayjs().format("YYYY-MM-DD")} ${row.end_time}`
                          ).format("HH:mm")
                        : "-"}
                    </TableCell>
                    <TableCell>{row.compound_name}</TableCell>
                    <TableCell>{row.batch_number}</TableCell>
                    <TableCell>{row.lot_no}</TableCell>
                    <TableCell>{row.recipe_name}</TableCell>
                    <TableCell>{row.recipe_description}</TableCell>
                    <TableCell>{row.batch_weight}</TableCell>
                    <TableCell>{row.total_batch_weight}</TableCell>
                    <TableCell>
                      {row.operator_name ? row.operator_name : "-"}
                    </TableCell>
                    <TableCell>
                      {row.supervisor_name ? row.supervisor_name : "-"}
                    </TableCell>
                    <TableCell>
                      {row.qa_supervisor_name ? row.qa_supervisor_name : "-"}
                    </TableCell>

                    <TableCell className="raw-material-btn-column">
                      <img
                        style={{ width: "26px" }}
                        src={images.editIcon}
                        onClick={() => handleEditClick(row)}
                        // value={robotHistoryData}
                        className="edit-btn"
                        alt=""
                      />
                      <img
                        style={{ width: "26px" }}
                        src={images.reportIcon}
                        onClick={() =>
                          navigate(`/raw-material-report/${row.id}`)
                        }
                        // value={robotHistoryData}
                        className="edit-btn"
                        alt=""
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          className="table-pagination"
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={getMaterialData ? getMaterialData.count : null}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        {isPopup ? (
          <>
            <div className="sendingdataaaa1">
              <Card className="pairingcard-Approved">
                <CardContent className="p-0 pairing-status">
                  <h4>Are you sure you want to get the excel ?</h4>
                </CardContent>
                <Button
                  className="pairingcard-btn"
                  style={{ margin: "20px 6px" }}
                  title="Yes"
                  onClick={() => handleExcelClick()}
                />
                <Button
                  className="pairingcard-btn"
                  title="No"
                  onClick={() => setisPopup(false)}
                />
              </Card>
            </div>
          </>
        ) : null}
        {successPopup && (
          <>
            <div className="sendingData">
              <Card className="card-printer">
                <CardContent>
                  <h4 className="card-content">
                    <b>
                      Email Sent to Your Mailbox!{" "}
                      <img
                        src={require("../../assets/images/correctIcon.png")}
                        style={{ height: "25px", width: "25px" }}
                      />
                    </b>
                  </h4>
                </CardContent>
              </Card>
            </div>
            <div className="sending-uid-overlay" on></div>
          </>
        )}
        {compounder?.toUpperCase() === "COAGULANT" ? (
          <>
            <Dialog open={open} onClose={handleClose} className="custom-dialog">
              <div className="dialog-fields-container">
                <div className="textFieldWrapper">
                  <TextField
                    fullWidth
                    label="Batch No."
                    value={editData.batchNo}
                    variant="filled"
                    onChange={(e) => handleChange("batchNo", e.target.value)}
                  />
                  <img
                    src={images.editIcon}
                    alt="edit icon"
                    onClick={(e) => handleChange("batchNo", e.target.value)}
                    className="editIcon"
                  />
                </div>
                <div className="textFieldWrapper">
                  <TextField
                    fullWidth
                    label="Foam test"
                    value={editData.foamTest}
                    variant="filled"
                    onChange={(e) => handleChange("foamTest", e.target.value)}
                  />
                  <img
                    src={images.editIcon}
                    alt="edit icon"
                    className="editIcon"
                  />
                </div>
                <div className="textFieldWrapper">
                  <TextField
                    fullWidth
                    label="Specific gravity"
                    value={editData.specificGravity}
                    variant="filled"
                    onChange={(e) =>
                      handleChange("specificGravity", e.target.value)
                    }
                  />
                  <img
                    src={images.editIcon}
                    alt="edit icon"
                    className="editIcon"
                  />
                </div>
                <div className="textFieldWrapper">
                  <TextField
                    fullWidth
                    label="Disperson tank no"
                    value={editData.disperson_tank_no}
                    variant="filled"
                    onChange={(e) =>
                      handleChange("disperson_tank_no", e.target.value)
                    }
                  />
                  <img
                    src={images.editIcon}
                    alt="edit icon"
                    className="editIcon"
                  />
                </div>
                <div className="textFieldWrapper">
                  <TextField
                    fullWidth
                    label="RPM"
                    value={editData.rpm}
                    variant="filled"
                    onChange={(e) => handleChange("rpm", e.target.value)}
                  />
                  <img
                    src={images.editIcon}
                    alt="edit icon"
                    className="editIcon"
                  />
                </div>
                <div className="textFieldWrapper">
                  <TextField
                    fullWidth
                    label="Total Weight"
                    value={editData.totalWeight}
                    variant="filled"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, ""); // Allow only numbers
                      handleChange("totalWeight", value);
                    }}
                    type="text"
                  />
                  <img
                    src={images.editIcon}
                    alt="edit icon"
                    className="editIcon"
                  />
                </div>
                <div className="textFieldWrapper">
                  <TextField
                    fullWidth
                    label="Remarks"
                    value={editData.remarks}
                    variant="filled"
                    multiline
                    onChange={(e) => handleChange("remarks", e.target.value)}
                  />
                  <img
                    src={images.editIcon}
                    alt="edit icon"
                    className="editIcon"
                  />
                </div>
                {userPermission.find(
                  (permission) => permission.module === "Raw Material"
                ).is_editor == true &&
                userPermission.find(
                  (permission) => permission.module === "Raw Material"
                ).is_viewer == true ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpdate}
                    className="custom-update-button"
                    title="Update"
                  ></Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleToastMsg}
                    className="custom-update-button"
                    title="Update"
                  ></Button>
                )}
              </div>
            </Dialog>
          </>
        ) : (
          <Dialog open={open} onClose={handleClose} className="custom-dialog">
            <div className="dialog-fields-container">
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  label="Lot No"
                  value={editData.lotNo}
                  variant="filled"
                  onChange={(e) => handleChange("lotNo", e.target.value)}
                />
                <img
                  src={images.editIcon}
                  alt="edit icon"
                  onClick={(e) => handleChange("lotNo", e.target.value)}
                  className="editIcon"
                />
              </div>
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  label="Fresh Latex Viscosity"
                  value={editData.freshLatexVelocity}
                  variant="filled"
                  onChange={(e) =>
                    handleChange("freshLatexVelocity", e.target.value)
                  }
                />
                <img
                  src={images.editIcon}
                  alt="edit icon"
                  className="editIcon"
                />
              </div>
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  label="Viscosity After Comp."
                  value={editData.viscosityAfterComp}
                  variant="filled"
                  onChange={(e) =>
                    handleChange("viscosityAfterComp", e.target.value)
                  }
                />
                <img
                  src={images.editIcon}
                  alt="edit icon"
                  className="editIcon"
                />
              </div>
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  label="M. Tank"
                  value={editData.mTank}
                  variant="filled"
                  onChange={(e) => handleChange("mTank", e.target.value)}
                />
                <img
                  src={images.editIcon}
                  alt="edit icon"
                  className="editIcon"
                />
              </div>
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  label="RPM"
                  value={editData.rpm}
                  variant="filled"
                  onChange={(e) => handleChange("rpm", e.target.value)}
                />
                <img
                  src={images.editIcon}
                  alt="edit icon"
                  className="editIcon"
                />
              </div>
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  label="GL02 (in KG)"
                  value={editData.gl02}
                  variant="filled"
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, ""); // Allow only numbers
                    handleChange("gl02", value);
                  }}
                  type="text"
                />
                <img
                  src={images.editIcon}
                  alt="edit icon"
                  className="editIcon"
                />
              </div>
              <div className="textFieldWrapper">
                <TextField
                  fullWidth
                  label="Remarks"
                  value={editData.remarks}
                  variant="filled"
                  multiline
                  onChange={(e) => handleChange("remarks", e.target.value)}
                />
                <img
                  src={images.editIcon}
                  alt="edit icon"
                  className="editIcon"
                />
              </div>
              {userPermission.find(
                (permission) => permission.module === "Raw Material"
              ).is_editor == true &&
              userPermission.find(
                (permission) => permission.module === "Raw Material"
              ).is_viewer == true ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpdate}
                  className="custom-update-button"
                  title="Update"
                ></Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleToastMsg}
                  className="custom-update-button"
                  title="Update"
                ></Button>
              )}
            </div>
          </Dialog>
        )}
      </div>
      <div className="d-flex justify-content-end aborted">
        <p style={{ margin: 0, marginBottom: 0 }}>
          Powered by <b>Hikar&#174;Technomation</b> Private Limited &#169; All
          Rights Reserved
        </p>
      </div>
    </>
  );
};

export default RawMaterial;
